// components/PlantConfiguration.js
import React from 'react';
import FieldCompression from './process-units/FieldCompression';
import InletSeparation from './process-units/InletSeparation';
import InletCompression from './process-units/InletCompression';
import Stabilisation from './process-units/Stabilisation';
import WasteWaterDisposal from './process-units/WasteWaterDisposal';
import Sweetening from './process-units/Sweetening';
import Dehydration from './process-units/Dehydration';
import Dewpoint from './process-units/Dewpoint';
import Fractionation from './process-units/Fractionation';
import SalesCompression from './process-units/SalesCompression';
import Utilities from './process-units/Utilities';

const PlantConfiguration = ({ activeUnits, configurations, setConfigurations }) => {
  // Helper function to update a specific unit's configuration
  const updateConfiguration = (unitName, newConfig) => {
    setConfigurations({
      ...configurations,
      [unitName]: {
        ...configurations[unitName],
        ...newConfig
      }
    });
  };

  return (
    <div className="plant-configuration">
      <div className="configuration-accordion">
        {activeUnits.fieldCompression && (
          <FieldCompression 
            config={configurations.fieldCompression} 
            updateConfig={(newConfig) => updateConfiguration('fieldCompression', newConfig)} 
          />
        )}
        
        {activeUnits.inletSeparation && (
          <InletSeparation 
            config={configurations.inletSeparation} 
            updateConfig={(newConfig) => updateConfiguration('inletSeparation', newConfig)} 
          />
        )}
        
        {activeUnits.inletCompression && (
          <InletCompression 
            config={configurations.inletCompression} 
            updateConfig={(newConfig) => updateConfiguration('inletCompression', newConfig)} 
          />
        )}
        
        {activeUnits.stabilisation && (
          <Stabilisation 
            config={configurations.stabilisation} 
            updateConfig={(newConfig) => updateConfiguration('stabilisation', newConfig)} 
          />
        )}
        
        {activeUnits.wasteWaterDisposal && (
          <WasteWaterDisposal 
            config={configurations.wasteWaterDisposal} 
            updateConfig={(newConfig) => updateConfiguration('wasteWaterDisposal', newConfig)} 
          />
        )}
        
        {activeUnits.sweetening && (
          <Sweetening 
            config={configurations.sweetening} 
            updateConfig={(newConfig) => updateConfiguration('sweetening', newConfig)} 
          />
        )}
        
        {activeUnits.dehydration && (
          <Dehydration 
            config={configurations.dehydration} 
            updateConfig={(newConfig) => updateConfiguration('dehydration', newConfig)} 
          />
        )}
        
        {activeUnits.dewpoint && (
          <Dewpoint 
            config={configurations.dewpoint} 
            updateConfig={(newConfig) => updateConfiguration('dewpoint', newConfig)} 
          />
        )}
        
        {activeUnits.fractionation && (
          <Fractionation 
            config={configurations.fractionation} 
            updateConfig={(newConfig) => updateConfiguration('fractionation', newConfig)} 
          />
        )}
        
        {activeUnits.salesCompression && (
          <SalesCompression 
            config={configurations.salesCompression} 
            updateConfig={(newConfig) => updateConfiguration('salesCompression', newConfig)} 
          />
        )}
        
        {activeUnits.utilities !== 'none' && (
          <Utilities 
            type={activeUnits.utilities}
            config={configurations.utilities} 
            updateConfig={(newConfig) => updateConfiguration('utilities', newConfig)} 
          />
        )}
      </div>
    </div>
  );
};

export default PlantConfiguration;